import {
  GET_CONTACT,
  GET_CONTACTS,
  ADD_CONTACT,
  UPDATE_CONTACT,
  REQUEST_UPDATE_CONTACT,
  DELETE_CONTACT,
  REQUEST_DELETE_CONTACT,
  REQUEST_ADD_CONTACT,
  GET_SOCIAL_STATUSES_OF_CONTACT,
  GET_PROBLEMATIQUES_OF_CONTACT,
  ERROR_XHR
} from '../mutation-types'

const state = {
  all: [],
  contact: {},
  socialStatusesOfContact: [],
  problematiquesOfContact: [],
  contactCreated: false,
  contactUpdated: false
}

const mutations = {
  [GET_CONTACTS] (state, contacts) {
    state.all = contacts.sort(function (a, b) {
      if (a.leader_lastname < b.leader_lastname) return -1
      if (a.leader_lastname > b.leader_lastname) return 1
      return 0
    })
    state.contactAdded = false
  },
  [GET_CONTACT] (state, contact) {
    state.contact = contact
  },
  // Contact creation
  [REQUEST_ADD_CONTACT] (state) {
    state.contactCreated = false
  },
  [ADD_CONTACT] (state, contact) {
    state.all.push(contact)
    state.contactCreated = contact.id
  },
  [REQUEST_UPDATE_CONTACT] (state) {
    state.contactUpdated = false
  },
  [UPDATE_CONTACT] (state, oldContact, updatedContact) {
    state.all.$remove(oldContact)
    state.all.push(updatedContact)
    state.contactUpdated = true
  },
  [REQUEST_DELETE_CONTACT] (state, contact) {
    state.contactDelete = false
  },
  [DELETE_CONTACT] (state, contact) {
    state.contactDelete = true
    state.all.$remove(contact)
  },
  [GET_SOCIAL_STATUSES_OF_CONTACT] (state, socialStatusesOfContact) {
    console.log(JSON.stringify(socialStatusesOfContact))
    state.socialStatusesOfContact = socialStatusesOfContact
  },
  [GET_PROBLEMATIQUES_OF_CONTACT] (state, problematiquesOfContact) {
    // console.log(JSON.stringify(problematiquesOfContact))
    state.problematiquesOfContact = problematiquesOfContact
  },
  [ERROR_XHR] (state, error) {
    console.log(state)
    console.log(error)
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/contacts.js